module.exports = "/_next/static/images/7558f2e9562e590ac8332cd7158e68a8-image-left-lg.jpg";